import { Button } from "antd"
import { ButtonProps } from "antd/lib"
import { CSSProperties, FC } from "react"

interface Props extends Omit<ButtonProps, 'size'> {
  icon: React.ReactNode
  size?: {
    width: number
    height: number
  }
}

export const ButtonWithIcon: FC<Props> = ({
  size: { width, height } = { width: 48, height: 48 },
  icon,
  ...props
}) => {
  const style: CSSProperties = {
    padding: 0,
    border: 'none',
    boxShadow: 'none',
    backgroundColor: '#F8F8F8',
    borderRadius: '50%',
    width,
    height,
    margin: 0,
    flexShrink: 0,
    ...props.style
  }

  return (
    <Button {...props} onClick={props.onClick} style={style}>
      {icon}
    </Button>
  )
}